/** Menu router_name / route.name keys used by sidebar resolveMenuLabel */
export default {
  deviceManage: 'Device Management',
  taskManage: 'Task Management',
  material_apply: 'Material Apply',
  robot_media_center: 'Media Center',
  enum_management: 'Enum Management',
  product_config: 'Product Config',
}
